import { RouteType } from "types/RouteType";

const dataIntegrityRoute: RouteType = {
  name: "DataIntegrity",
  path: "/admin/data-integrity",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Data Integrity Checker",
      enableRefreshButton: true,
      color: "primary",
    },
    body: {
      component: () => import("./DataIntegrity.Body"),
      grayBackground: false,
    },
  },
  group: "Admin",
  searchAliases: ["integrity", "consistency", "orphans"],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
};

export default dataIntegrityRoute;
